// extracted by mini-css-extract-plugin
export default {"flexWrapper":"FlexWrapper_flexWrapper__NTQ3g"};